<template>
  <div>
    <data-table ref="dataTable" :option="option"> </data-table>
  </div>
</template>
<script>
import { DataTable } from "@/components/dataTable";
import cloneDeep from "lodash/cloneDeep";
export default {
  components: {
    DataTable
  },
  props: {
    code: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  watch: {
    code(val) {
      if (val) {
        this.init();
      }
    }
  },
  data() {
    return {
      option: {},
      content: [
        {
          label: "名称",
          name: "Name",
          option: {
            rules: [{ required: true, message: "名称必填" }]
          }
        },
        {
          label: "排序",
          name: "Sort",
          type: "number",
          props: {
            min: 0
          }
        }
      ],
      columns: [
        {
          title: "序号",
          width: 80,
          align: "center",
          type: "indexcolumn"
        },
        {
          title: "名称",
          dataIndex: "Name"
        },
        {
          title: "排序",
          width: 200,
          dataIndex: "Sort"
        },
        {
          title: "操作",
          dataIndex: "Id",
          width: 300,
          key: "action",
          align: "center",
          scopedSlots: { customRender: "rowAction" }
        }
      ],
      formContent: [],
      gridColumms: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.formContent = cloneDeep(this.content);
      this.gridColumms = cloneDeep(this.columns);
      if (this.code == "RestaurantMarket") {
        this.formContent.splice(1, 0, {
          label: "分市时间",
          name: "Value",
          option: {
            rules: [{ required: true, message: "分市时间必填" }]
          }
        });
        this.gridColumms.splice(2, 0, {
          title: "分市时间",
          width: 200,
          dataIndex: "Value"
        });
      }
      this.option = {
        headSearch: {
          colnum: 1,
          content: [
            {
              label: "名称",
              name: "Name"
            }
          ]
        },
        form: {
          title: this.title,
          width: 500,
          colnum: 1,
          content: this.formContent,
          add: {
            submitApi: "Maintenance_Add",
            onOpenAfter: () => {
              let values = { Sort: "0" };
              return values;
            },
            onSubmitBefore: values => {
              return this.onSubmitBefore(values);
            }
          },
          edit: {
            infoApi: "Maintenance_Get",
            submitApi: "Maintenance_Edit",
            onSubmitBefore: values => {
              return this.onSubmitBefore(values);
            }
          },
          del: {
            submitApi: "Maintenance_Del"
          }
        },
        grid: {
          api: "MaintenancePage_List",
          params: { Type: this.code },
          columns: this.gridColumms
        }
      };
    },
    onSubmitBefore(values) {
      values.Type = this.code;
      return values;
    }
  }
};
</script>

<style lang="less" scoped></style>
